module.exports = __webpack_public_path__ + "f5877d6e14db557e108964bd953d046c.svg";